module.exports = __webpack_public_path__ + "img/Bard.15a0ff36.png";